/**
* =========================================================================================
* Input Skeleton
* =========================================================================================
*/

import React from 'react';
import Skeleton from './index';

const TSkeleton = (props) => {

    const rowCount = props?.rows ?? props?.length ?? props?.size ?? 10;

    return (
        <React.Fragment>
            {
                Array.from(Array(rowCount).keys()).map(a_number => {
                    return (
                        <tr className="u_skeleton-table" key={a_number}>
                            {
                                Array.from(Array(props?.col ? props?.col : 1).keys()).map(number => {
                                    return (
                                        <td key={number}>
                                            <Skeleton height="18px" />
                                        </td>
                                    )
                                })
                            }
                        </tr>
                    )
                })
            }
        </React.Fragment>
    );
}

export default TSkeleton;
